'use es6';

import Immutable from 'immutable';
import { cleanObject } from '../utils/formatters';
const EMPTY_MAP = Immutable.Map();
const EMPTY_LIST = Immutable.List();
const defaults = {
  awardName: '',
  defaultName: '',
  displayNames: EMPTY_MAP,
  iconUrl: '',
  trackIds: EMPTY_LIST
};

class Certification extends Immutable.Record(defaults) {
  constructor(json = {}) {
    const jsonCopy = Object.assign({}, json);

    if (json.displayNames) {
      jsonCopy.displayNames = Immutable.fromJS(json.displayNames);
    }

    if (json.trackIds) {
      jsonCopy.trackIds = Immutable.List(json.trackIds);
    }

    super(cleanObject(jsonCopy));
  }

  getDisplayName(lang) {
    return this.hasIn(['displayNames', lang]) ? this.getIn(['displayNames', lang]) : this.get('defaultName');
  }

}

export default Certification;